import React from 'react';
import UserService from '../services/UserService';

class EnsureUser extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      user: null
    }
  }

  componentDidMount() {
    UserService
      .getCurrentUserProfile()
      .then(({ id, attributes }) => this.setState({ user: { id, ...attributes } }));
  }

  render() {
    const { ...renderProps } = this.state;
    return this.props.render(renderProps);
  }
}

export default EnsureUser;



// WEBPACK FOOTER //
// ./src/components/EnsureUser.js